// extracted by mini-css-extract-plugin
module.exports = {"iconSelect":"FeatureLineWeightEditor_iconSelect__3PSbf"};